export interface MimeAttachmentContent {
  filename: string;
  mimeType: string;
  content: string | Uint8Array;
}

export type AttachmentPreviewKind = "image" | "pdf" | "text" | "unsupported";

export const attachmentContentToBlob = (attachment: MimeAttachmentContent): Blob => {
  let blobContent: BlobPart;
  if (typeof attachment.content === "string") {
    const binary = atob(attachment.content);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    blobContent = bytes;
  } else {
    blobContent = attachment.content;
  }
  return new Blob([blobContent], { type: attachment.mimeType });
};

export const getAttachmentPreviewKind = (
  mimeType: string,
  filename: string
): AttachmentPreviewKind => {
  const lower = mimeType.toLowerCase();
  const ext = (filename.split(".").pop() || "").toLowerCase();

  if (lower.startsWith("image/") || ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"].includes(ext)) {
    return "image";
  }
  if (lower === "application/pdf" || ext === "pdf") {
    return "pdf";
  }
  if (
    lower.startsWith("text/") ||
    lower === "application/json" ||
    ["txt", "csv", "json", "xml", "html", "htm", "log", "md"].includes(ext)
  ) {
    return "text";
  }
  return "unsupported";
};

export const canPreviewAttachment = (mimeType: string, filename: string): boolean =>
  getAttachmentPreviewKind(mimeType, filename) !== "unsupported";

export const downloadAttachmentBlob = (attachment: MimeAttachmentContent): void => {
  const blob = attachmentContentToBlob(attachment);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = attachment.filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
